/* Netcarat: on-demand YouTube/Vimeo embed. No iframe until the user clicks Play. */
(() => {
  if (window.__netcaratExternalVideoRegistered) return;
  window.__netcaratExternalVideoRegistered = true;

  function embedUrl(value) {
    let url;
    try { url = new URL(value); } catch { return null; }
    if (url.protocol !== 'https:') return null;
    const host = url.hostname.toLowerCase();
    let id = '';
    if (host === 'youtu.be' || host === 'www.youtu.be') {
      id = url.pathname.split('/').filter(Boolean)[0] || '';
    } else if (['youtube.com', 'www.youtube.com', 'm.youtube.com'].includes(host)) {
      if (url.pathname === '/watch') id = url.searchParams.get('v') || '';
      else if (/^\/(shorts|embed)\//.test(url.pathname)) id = url.pathname.split('/')[2] || '';
    }
    if (id && /^[A-Za-z0-9_-]{11}$/.test(id)) {
      return 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    }
    if (host === 'vimeo.com' || host === 'www.vimeo.com' || host === 'player.vimeo.com') {
      const parts = url.pathname.split('/').filter(Boolean);
      const numeric = parts.find((part) => /^\d+$/.test(part));
      if (numeric) {
        const hash = url.searchParams.get('h') || '';
        return 'https://player.vimeo.com/video/' + numeric + (hash ? '?h=' + encodeURIComponent(hash) + '&autoplay=1' : '?autoplay=1');
      }
    }
    return null;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-netcarat-video-play]');
    if (!button) return;
    const host = button.closest('[data-netcarat-video-url]');
    if (!host) return;
    const src = embedUrl(host.dataset.netcaratVideoUrl || '');
    if (!src) {
      button.querySelector('.netcarat-external-video__label').textContent = 'Video link unavailable';
      return;
    }
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = 'Netcarat jewellery product video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    host.replaceChildren(iframe);
  });
})();
